import RiskAssessment from './RiskAssessmentMatrix';

export default RiskAssessment;
